/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_Group_PeopleInputs */

const cs_nav_settings_group_people = /** @type {(inputs: Nav_Settings_Group_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé`)
};

const en_nav_settings_group_people = /** @type {(inputs: Nav_Settings_Group_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Nav_Settings_Group_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_group_people = /** @type {((inputs?: Nav_Settings_Group_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_Group_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_group_people(inputs)
	return cs_nav_settings_group_people(inputs)
});